const collectionsState = {
  data: {
    title: '',
    description: '',
    domainId: '',
    actionBucketData: {
      isAllPagesSelected: false,
      bucketType: 'recirculation',
      criteria: {},
      pageIds: [],
      documentIds: [],
      engine: '',
      pageSelectionType: 'manual',
      contentExtractionAuthConfig: {
        loginURL: '',
        username: '',
        password: '',
      },
    },
  },
  etc: {
    collectionsStep: 0,
    isCollectionsSubmittable: false,
    collectionType: 'pageUrls',
    creationType: '',
    selectedUrlsToCrawl: [],
    KAUploadedDataCount: {
      KAPageUrls: 0,
      KAUploadedDocuments: 0,
    },
    selectedAssetsToCrawlType: 'pageUrls',
    isWordpressConnected: false,
    targetPagesList: [],
    selectedRowKeys: [],
    selectedRows: [],
    isContentMappingCompleted: false,
    criteriaFilteredListCount: 0,
    isAuthRequired: false,
    /** Manual KA URL + file upload: `{ pageId, labels, isSpecialCrawlingActive, url?, title? }[]` after POST /Page/addPageManuallyWithFile */
    kaManualUploadPageIdsWithLabels: [],
  },
};

export default collectionsState;
